import React from 'react';
import AtlasV2DorisSplineChart from 'src/components/AtlasV2Components/AtlasV2graphs/AtlasV2DorisSplineChart';
import { METRICTYPE } from 'src/utils/entityDefinitions';

const AtlasUnitsSoldNon1PMarketShareSplineChart = () => {
  return (
    <AtlasV2DorisSplineChart
      queryKey="UnitsSoldNon1PMarketShareSplineChart"
      title="Market Share of Units Sold"
      methodName="sales/GetSalesMetrics"
      metricTypeDisplay={METRICTYPE.PERCENT}
      metricType="unitsSold"
      showMarketShare={true}
    />
  );
};

export default AtlasUnitsSoldNon1PMarketShareSplineChart;
